import React from "react";
import { BetSelection } from "@tvg/ts-types/Bet";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";
import {
  DetailAction,
  HorizontalRule,
  LabelIconWrapper,
  LabelItem,
  PickBetContainer,
  PickBetHrContainer,
  PickBetLabelIconContainer,
  PickBetLabelRunnersWrapper,
  PickBetsExpandButton,
  PickBetsWrapper,
  RunnerNumberContainer,
  TextLabel,
  WillPaysInfoContainer,
  WillPaysInfoDesktopText,
  WillPaysLabel
} from "../styled-components";
// @ts-ignore
import IconDescription from "../../IconDescription";
// @ts-ignore
import Icon from "../../../_static/Icons";
// @ts-ignore
import { chevronDown, chevronUp } from "../../../_static/Icons/iconsDuotone";
// @ts-ignore
import buildColor from "../../../_static/ColorPalette";

import LabelIcon from "./LabelIcon";
import ScratchNotifications from "./ScratchNotifications";

export interface PickBetLayoutProps {
  raceStatus: string;
  isDesktop: boolean;
  isBetsDetailedView: boolean;
  showUpperHorizontalRule: boolean;
  isCanceled: boolean;
  showHorizontalRule: boolean;
  isFirstRowOfRunners: boolean;
  runners: BetSelection[];
  hasDetails: boolean;
  onDetailedView?: () => void;
  label: string;
  pickBetsLabelLength: number;
  isLastRowOfRunners: boolean;
  runnersHaveWillPayAmount: boolean;
  isPickBet: boolean;
  wagerTypeCode: WagerTypeCodesEnum;
  isRaceOver: boolean;
  hasAlternates: boolean;
  hasAlternateReplacement: boolean;
  runnerNumberGroup: React.ReactNode;
}

const PickBetLayout = ({
  raceStatus,
  isBetsDetailedView,
  showHorizontalRule,
  isCanceled,
  isDesktop,
  showUpperHorizontalRule,
  isFirstRowOfRunners,
  runners,
  onDetailedView,
  hasDetails,
  label,
  pickBetsLabelLength,
  isLastRowOfRunners,
  runnersHaveWillPayAmount,
  wagerTypeCode,
  isPickBet,
  isRaceOver,
  hasAlternates,
  runnerNumberGroup,
  hasAlternateReplacement
}: PickBetLayoutProps) => (
  <PickBetContainer
    data-qa-label="myBets-pickBets-container"
    raceStatus={raceStatus}
    isCanceled={isCanceled}
    isBetsDetailedView={isBetsDetailedView}
    isDesktop={isDesktop}
    showHorizontalRule={showHorizontalRule}
    showUpperHorizontalRule={isDesktop && showUpperHorizontalRule}
  >
    {!isCanceled &&
      !isFirstRowOfRunners &&
      isBetsDetailedView &&
      (runners.length > 1 || hasAlternates) && (
        <PickBetHrContainer
          data-qa-label="myBets-hr-container"
          isTopHr
          isDesktop={isDesktop}
        >
          <HorizontalRule data-qa-label="myBets-horizontal-line" isPickBets />
        </PickBetHrContainer>
      )}
    <PickBetsWrapper data-qa-label="myBets-pickBets-wrapper">
      {hasDetails && <DetailAction onClick={onDetailedView} />}
      {!isCanceled && (
        <PickBetLabelIconContainer
          isDesktop={isDesktop}
          raceStatus={raceStatus}
        >
          <LabelIconWrapper
            isDesktop={isDesktop}
            raceStatus={raceStatus}
            data-qa-label="myBets-icon-wrapper"
          >
            <LabelIcon
              raceStatus={raceStatus}
              label={label}
              isDesktop={isDesktop}
            />
          </LabelIconWrapper>
        </PickBetLabelIconContainer>
      )}
      <PickBetLabelRunnersWrapper
        data-qa-label="myBets-label-runners-wrapper"
        detailExpanded={isBetsDetailedView}
      >
        {!isDesktop && (
          <LabelItem
            isPickBets
            pickBetsLabelLength={pickBetsLabelLength}
            pickBetsDetailExpanded={isBetsDetailedView}
            data-qa-label="myBets-label-wrapper"
          >
            <TextLabel
              data-qa-label="myBets-pickBets-label"
              raceStatus={raceStatus}
              isPickBets
            >
              {label}
            </TextLabel>
          </LabelItem>
        )}
        {isBetsDetailedView &&
          isLastRowOfRunners &&
          runnersHaveWillPayAmount && (
            <WillPaysInfoContainer isDesktop={isDesktop}>
              {isDesktop ? (
                <WillPaysInfoDesktopText>
                  Will Pays subject to change due to scratches
                </WillPaysInfoDesktopText>
              ) : (
                <IconDescription
                  id="willpays-info"
                  icon="info"
                  isDuotone
                  size={16}
                  viewBoxSize={16}
                  color="blue_accent"
                  variation="200"
                  stroke="blue_accent"
                  strokeVariation="700"
                  textColor="blue_accent"
                  textColorVariation="700"
                  iconMargin={12}
                  description="Will Pays subject to change due to scratches"
                  fontSize={12}
                />
              )}
            </WillPaysInfoContainer>
          )}
        {isBetsDetailedView &&
          isPickBet &&
          wagerTypeCode &&
          raceStatus === "attention" &&
          !isRaceOver &&
          !runnersHaveWillPayAmount &&
          !isDesktop && (
            <ScratchNotifications
              wagerTypeCode={wagerTypeCode}
              isDesktop={isDesktop}
              hasAlternateReplacement={hasAlternateReplacement}
            />
          )}
        <RunnerNumberContainer data-qa-label="myBets-runner-number-container">
          {runnerNumberGroup}
        </RunnerNumberContainer>
        {isBetsDetailedView &&
          isPickBet &&
          wagerTypeCode &&
          raceStatus === "attention" &&
          !isRaceOver &&
          !runnersHaveWillPayAmount &&
          isDesktop && (
            <ScratchNotifications
              wagerTypeCode={wagerTypeCode}
              isDesktop={isDesktop}
              hasAlternateReplacement={hasAlternateReplacement}
            />
          )}
      </PickBetLabelRunnersWrapper>
      {hasDetails &&
        isBetsDetailedView &&
        isLastRowOfRunners &&
        runnersHaveWillPayAmount &&
        !isDesktop && <WillPaysLabel>WILL PAYS</WillPaysLabel>}
      {hasDetails && !isDesktop && (
        <PickBetsExpandButton onClick={onDetailedView}>
          <Icon
            icon={isBetsDetailedView ? chevronUp : chevronDown}
            viewBoxSize={16}
            size={16}
            color="transparent"
            stroke={buildColor("grey", "800")}
          />
        </PickBetsExpandButton>
      )}
    </PickBetsWrapper>
    {showHorizontalRule &&
      isBetsDetailedView &&
      (runners.length > 1 || hasAlternates) &&
      !isCanceled && (
        <PickBetHrContainer
          data-qa-label="myBets-hr-container"
          isDesktop={isDesktop}
        >
          <HorizontalRule data-qa-label="myBets-horizontal-line" isPickBets />
        </PickBetHrContainer>
      )}
  </PickBetContainer>
);

export default PickBetLayout;
